import { DealsQueries } from "store/types";

export enum DealViews {
  Dashboard = "dashboard",
  PIPELINE = "pipeline",
  GRID = "grid",
  TABLE = "table"
}

export enum DealsOrderBy {
  TITLE = "title",
  LAST_MODIFIED = "last_updated_relation",
  LATEST_CREATED = "created_at"
}

export const defaultDealsQueries: DealsQueries = {
  filters: { "Asset Class": [], "Deal Status": [] },
  deal_title: "",
  view: DealViews.PIPELINE,
  order_by: DealsOrderBy.LAST_MODIFIED,
  tableColumns: [],
  cubicInvestorView: {},
  chartInvestorView: {}, //we receive this from server
  summaryTableInvestorView: {
    measures: ["Commitment"],
    characteristics: [],
    calculatedFields: ["Adjusted NAV", "IRR", "MOIC", "DPI"]
  },
  descriptionTableInvestorView: {
    measures: ["Commitment"],
    characteristics: [],
    calculatedFields: []
  }

  // tableColumns: [
  //   "title",
  //   "created_at",
  //   "asset_class",
  //   "sub_asset_class",
  //   "deal_status",
  //   "deal_stage",
  //   "minimum_ticket",
  //   "geography"
  // ],
  // cubicInvestorView: {
  //   ["cubic1"]: { title: "All Deals", filter: "All Deals" },
  //   ["cubic2"]: { title: "MOIC", filter: "MOIC" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" }
  // },
};

export interface IOpportunitiesStatuses {
  INTERESTED: "interested";
  LATER: "later";
  APPLY: "apply";
}

export const opportunityStatuses: IOpportunitiesStatuses = {
  INTERESTED: "interested",
  LATER: "later",
  APPLY: "apply"
};
export const FileUnderScanningMessage = "We are scanning files for malware, files will be available soon.";

export enum DealRedirect {
  FirstFolderMeta = "firstFolderMeta",
  FirstForm = "firstForm",
  Dashboard = "dashboard",
  Workspace = "workspace",
  FirstDocument = "firstDocument"
}

export const DATABOX_MIN_WIDTH_PX = 300;
export const DATABOX_MAX_WIDTH_PX = 600;

export const REQUIRED_FOR_STAGE_KEY = "requiredForStage";
export const MISSING_FIELD_IDS_KEY = "missingFieldIds";
export const TARGET_STAGE_NAME_KEY = "targetStageName";
export const MISSING_FIELD_NAMES_KEY = "missingFieldNames";
/** When opening from "Review missing fields" while already on deal page, ensures URL changes so the drawer opens again */
export const REVIEW_TRIGGER_KEY = "reviewTrigger";
